var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-schedule.373fc0a1.png","uri@2x": __webpack_public_path__ + "icon-schedule.41ca1086.png","uri@3x": __webpack_public_path__ + "icon-schedule.295c9ab1.png",
    width: 20,
    height: 19
});